import React, { useContext } from "react";
import PropTypes from "prop-types";

import { ALL_CUSTOMER_CONTACTS_QUERY } from "../../../../graphql/CustomerContacts/CustomerContacts.graphql";

import { CUSTOMER_CONTACT_COLUMNS } from "../columns";
import DataTable from "../../../../components/DataTable";

import { EditCustomerContactForm } from "../../../../components/CustomerContacts";

import { ModalContext } from "../../../../components/ModalProvider";

const Contacts = ({ id }) => {
  const { setModalOpen } = useContext(ModalContext);

  return (
    <DataTable
      columns={CUSTOMER_CONTACT_COLUMNS}
      dataQuery={ALL_CUSTOMER_CONTACTS_QUERY}
      name="CustomerContact"
      where={{ CustomerRecIdRef: parseInt(id) }}
      onRowClick={data =>
        setModalOpen(
          true,
          <EditCustomerContactForm
            customerContact={data}
            setModalOpen={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
};

Contacts.propTypes = {
  id: PropTypes.number
};

export default Contacts;
